const API_URL = process.env.REACT_APP_API_URL;
export const GET_USER_CLAIM_URL = process.env.REACT_APP_API_USER_CLAIM_URL;
export const GET_USER = API_URL + "/user/";
export const ACCOUNT = API_URL + "/account";
export const SUBANNOUNCEMENTS = API_URL + "/announcement/subscription";
export const ORGANIZATION = API_URL + "/organization/";